<template>
  <v-card outlined class="mb-4">
    <v-card-title class="subtitle-1 font-weight-bold">
      <v-icon left>mdi-scale-balance</v-icon>
      Legal Settings
    </v-card-title>
    
    <v-card-text>
      <v-checkbox
        v-model="localConfig.autoGenerate"
        label="Auto-generate Legal Pages (Terms & Privacy)"
        hide-details
        class="mb-4"
        @change="emitUpdate"
      />

      <div v-if="!localConfig.autoGenerate">
        <v-text-field
          v-model="localConfig.termsUrl"
          label="Terms of Service URL *"
          placeholder="https://www.example.com/terms"
          outlined
          dense
          class="mb-4"
          @input="emitUpdate"
        />

        <v-text-field
          v-model="localConfig.privacyPolicyUrl"
          label="Privacy Policy URL *"
          placeholder="https://www.example.com/privacy"
          outlined
          dense
          class="mb-4"
          @input="emitUpdate"
        />
      </div>

      <v-text-field
        v-model="localConfig.consentText"
        label="Consent Text (before links)"
        placeholder="I agree to the"
        outlined
        dense
        class="mb-2"
        @input="emitUpdate"
      />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "LegalConfigPanel",
  props: {
    value: {
      type: Object,
      default: () => ({}),
    }
  },
  data() {
    return {
      localConfig: {
        autoGenerate: this.value.autoGenerate !== false,
        termsUrl: this.value.termsUrl || "",
        privacyPolicyUrl: this.value.privacyPolicyUrl || "",
        consentText: this.value.consentText || "I agree to the"
      }
    };
  },
  watch: {
    value: {
      deep: true,
      handler(val) {
        this.localConfig = {
          autoGenerate: val.autoGenerate !== false,
          termsUrl: val.termsUrl || "",
          privacyPolicyUrl: val.privacyPolicyUrl || "",
          consentText: val.consentText || "I agree to the"
        };
      }
    }
  },
  methods: {
    emitUpdate() {
      this.$emit("input", { ...this.localConfig });
    }
  }
};
</script>